"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SkipLinkButton = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _createFocusRingStyles = require("../../../util/createFocusRingStyles");
var _withFocusClassName = require("../../../util/withFocusClassName");
var _clickable = require("../../clickable");
// TODO should this just be a button? Why does it need to be an anchor?
// TODO is it just for the href? Do we really need to support that?!
const SkipLinkButton = (0, _withFocusClassName.withFocusToggleClassName)((0, _styled.default)(_clickable.Clickable)(_ref => {
  let {
    theme
  } = _ref;
  return `
    box-sizing: border-box;
    height: 24px;
    margin: 0;
    padding: ${theme.skipLink.button.padding};
    font-size: ${theme.skipLink.button.fontSize};
    line-height: ${theme.skipLink.button.lineHeight};
    outline: none;
    text-decoration: none;
    overflow: "hidden";
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100vw;
    cursor: pointer;
    color: ${theme.skipLink.button.color};

    ${(0, _createFocusRingStyles.createFocusRingStyles)({
    theme: theme.key,
    componentRadius: theme.skipLink.button.borderRadius,
    gap: theme.skipLink.button.focusRingGap,
    componentBorderWidth: 1,
    innerColorOverride: "transparent"
  })};
`;
}));
exports.SkipLinkButton = SkipLinkButton;
//# sourceMappingURL=SkipLinkButton.js.map